const NOT_VALID = 'NOT_VALID'
const QUOTE_NOT_SUPPORTED = 'error.quote.notSupported'
const ROUTE_NOT_SUPPORTED = 'error.route.not.supported'

export { NOT_VALID, QUOTE_NOT_SUPPORTED, ROUTE_NOT_SUPPORTED }
